import React from 'react';
import { StyleSheet, Text, useWindowDimensions, View, } from 'react-native';
import { ColorTokens } from '@voltmoney/schema';
import RenderHtml from 'react-native-render-html';
import { isWeb } from "../pages/utils";
import ThemeProvider from "@voltmoney/theme";
const TermsText = ({ html, onPress, triggerAction, termsAction, privacyAction, action, }) => {
    const theme = ThemeProvider.getTheme();
    const colorMapping = theme.colors;
    const { width } = useWindowDimensions();
    const source = {
        html: `${html}`,
    };
    return isWeb() && !html ? (React.createElement(React.Fragment, null,
        React.createElement(Text, { style: styles.termText },
            "By proceeding, I accept the",
            ' ',
            React.createElement(Text, { nativeID: 'txt_loginScreen_termsAndCondition', style: [styles.termTextBlue, { color: colorMapping[ColorTokens.Primary_100] }], onPress: () => { termsAction && triggerAction(termsAction); } }, "T&Cs"),
            " and",
            ' ',
            React.createElement(Text, { nativeID: 'txt_loginScreen_privacyPolicy', style: [styles.termTextBlue, { color: colorMapping[ColorTokens.Primary_100] }], onPress: () => { privacyAction && triggerAction(privacyAction); } }, "Privacy policy")))) :
        (React.createElement(React.Fragment, null,
            React.createElement(View, null,
                React.createElement(RenderHtml, { contentWidth: width, source: source }))));
};
export default React.memo(TermsText);
export { TermsText };
const styles = StyleSheet.create({
    termText: {
        fontWeight: '400',
        fontSize: 10,
        color: '#667085'
    },
    termTextBlue: {
        fontWeight: '500',
        fontSize: 10,
        lineHeight: 16,
        fontFamily: 'Inter'
    }
});
